import {RouteConfig} from "vue-router";

const manageCodRoutes: Array<RouteConfig> = [
    {
        path: "manage-cod",
        component: () => import("./index.vue"),
        name: "codCustomer",
        meta: { title: "Quản lý tiền hàng" }
    }
];

export default manageCodRoutes;
